// @flow

import type { ExtractReturn } from '@ta/common.types';
import type { Action as AllActions } from './state';

export const SET_AUTH_STATE = 'SET_AUTH_STATE';

type CaptchaConfig = {|
  needsRecaptcha: boolean,
  needsGeetest: boolean,
  captchaSiteKey: string,
  recaptchaLang: string,
|};

export type State = {|
  isMember: boolean,
  csrfToken: string,
  altSessId: string,
  loggedInUserId: string,
  captcha: CaptchaConfig,
|};

export const setLoggedInUserId = (loggedInUserId?: string) => ({
  type: SET_AUTH_STATE,
  loggedInUserId,
});

export type Action = ExtractReturn<typeof setLoggedInUserId>;

const emptyState = () => ({
  isMember: false,
  csrfToken: '',
  altSessId: '',
  loggedInUserId: '',
  captcha: {
    needsRecaptcha: false,
    needsGeetest: false,
    captchaSiteKey: '',
    recaptchaLang: '',
  },
});

export default (state: State = emptyState(), action: AllActions): State => {
  switch (action.type) {
    case SET_AUTH_STATE:
      return {
        ...state,
        loggedInUserId: action.loggedInUserId,
        isMember: !!action.loggedInUserId,
      };
    default:
      return state;
  }
};
